import { CountdownTimer } from './countdown';
import { translations } from './translations';
import { updateHeaderHeight } from '../../js/front/header';

document.querySelectorAll( '.b-popup' ).forEach( ( block ) => {

	const popup = block.closest( '.popup' );
	const popupCounter = block.querySelector( '.b-popup-counter' );

	if ( popupCounter ) {

		new CountdownTimer( popupCounter, translations );

	}

	if ( !popup.classList.contains( 'popup--format-banner' ) ) {

		return;

	}

	/**
	 * Set visibility in sessionStorage (per popup)
	 * @param {boolean} visible
	 */
	const setPopupVisibility = ( visible ) => {

		const key = `popupVisible_${block.dataset.id || 'default'}`;

		if ( visible ) {

			sessionStorage.setItem( key, 'true' );

		} else {

			sessionStorage.setItem( key, 'false' );

		}

	};

	/**
	 * Close popup
	 */
	const closePopup = () => {

		const closeButton = block.querySelector( '.b-popup__close' );

		if ( closeButton ) {

			closeButton.addEventListener( 'click', () => {

				setPopupVisibility( false );

				popup.classList.remove( 'is-active' );
				document.documentElement.style.setProperty( '--banner-height', `0px` );

				updateHeaderHeight();

			} );

		}

	};

	closePopup();

	/**
	 * Check visibility
	 */
	const checkPopupVisibility = () => {

		const key = `popupVisible_${block.dataset.id || 'default'}`;
		const visible = sessionStorage.getItem( key );

		if ( visible === 'false' ) {

			popup.classList.remove( 'is-active' );
			document.documentElement.style.setProperty( '--banner-height', `0px` );

			return;

		}

		popup.classList.add( 'is-active' );

		requestAnimationFrame( () => {

			setPopupHeight();

		} );

	};

	checkPopupVisibility();

	/**
	 * Set height
	 */
	const setPopupHeight = () => {

		setTimeout( () => {

			const height = block.scrollHeight;

			document.documentElement.style.setProperty(
				'--banner-height',
				`${height}px`
			);
			updateHeaderHeight();

		}, 0 );

	};

	/**
	 * Creates a debounced version of a function.
	 *
	 * @param {Function} fn - The function to debounce.
	 * @param {number} [delay=100] - Delay in milliseconds.
	 * @return {Function} Debounced function.
	 */
	const debounce = ( fn, delay = 100 ) => {

		let timeout;

		return ( ...args ) => {

			clearTimeout( timeout );
			timeout = setTimeout( () => fn.apply( ...args ), delay );

		};

	};

	window.addEventListener( 'resize', debounce( setPopupHeight, 150 ) );

	window.addEventListener( 'load', () => {

		setPopupHeight();

	} );

} );
